import {useCallback, useEffect, useState} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {Menu} from 'antd';
import {observer} from 'mobx-react-lite';
import userInfoStore from '@/store/ServiceInfoStore';
import {menuItems, menuItemsOpenService} from '@/dicts/constants';
import {ServiceStatusEnum} from '@/dicts/enum';

const CompMenu = observer(function CompMenu() {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        serviceStatus,
    } = userInfoStore;
    const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([]);
    const [menus, setMenus] = useState<any[]>([]);

    useEffect(
        () => {
            (serviceStatus || serviceStatus === 0) && setMenus(
                [
                    ServiceStatusEnum.NOT_OPENED,
                ].includes(serviceStatus) ? menuItemsOpenService : menuItems
            );
        },
        [serviceStatus]
    );

    useEffect(
        () => {
            const pathname = location.pathname;
            // 判断pathname是否包含在menuItemsOpenService1的path或child的path中，如果存在，设置defaultSelectedKeys为该item的key，用es6实现
            const selectedKey = menus
                .find(item => item.path === pathname || item.child?.some(child => child.path === pathname))?.key;
            if (selectedKey) {
                setDefaultSelectedKeys([selectedKey]);
            }
        },
        [menus, location]
    );

    const handleClick = useCallback(
        (v: {key: string}) => {
            // es6遍历获取items数组对象中的path属性值
            const menuItem = menuItems.find(item => item.key === v.key);
            menuItem?.path && navigate(menuItem.path);
            // 触发状态请求
            if (menuItem?.path === '/service-management') {
                userInfoStore.getServiceInfo();
            }
            // navigate('/service-management');
        },
        [navigate]
    );
    return (
        <Menu
            mode="inline"
            inlineIndent={10}
            selectedKeys={defaultSelectedKeys}
            style={{height: 'calc(100% - 56px)', borderInlineEnd: 0}}
            items={menus}
            onClick={handleClick}
        />
    );
});
export default CompMenu;
